import script from "./PageTracker.vue?vue&type=script&setup=true&lang=js"
export * from "./PageTracker.vue?vue&type=script&setup=true&lang=js"

import "./PageTracker.vue?vue&type=style&index=0&id=ea587942&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea587942"]])

export default __exports__